<template>
    <div>
        <table class="smallText text-center">
            <tr>
                <td colspan="8" class="noBorder text-left px-0">
                    <span class="grey--text text--darken-1 mr-2">{{label}}:</span>
                    <span class="subtitle-1 font-weight-bold text-truncate mb-1'">
                        <span>{{dataObject[type].vereinsNr}}</span>
                        <span v-if="$vuetify.breakpoint.smAndUp"> / </span><br v-else>
                        <span>{{dataObject[type].teamName}}</span>
                    </span>
                </td>
            </tr>
            <tr class="text-center font-weight-bold grey lighten-4">
                <td class="text-left pl-2" style="width: 160px">Name/Pass</td>
                <td>FW</td>
                <td v-if="isCup" class="text-center px-1"/>
                <td>1.DG</td>
                <td>2.DG</td>
                <td>3.DG</td>
                <td>4.DG</td>
                <td v-if="!isCup"><div>Kegel</div><div>SaP</div></td>
                <td class="borderRight">
                    <span v-if="!isCup">MaP</span><span v-else >Kegel</span>
                </td>
            </tr>
            <tr v-for="i in numberOfSpieler" :key="i">
                <td class="spieler text-left pl-2" style="height: 40px">
                    <div>{{dataObject.partien[i][type].spieler.name.substr(8)}}</div>
                    <div class="caption grey--text text--darken-1 d-inline-block"
                    style="line-height: 1.2">
                        {{dataObject.partien[i][type].spieler.name.substr(0,6)}}</div>
                    <div class="caption grey--text text--darken-1 d-inline-block"
                         style="line-height: 1.2; float: right">
                        <span>{{dataObject.getAltersklasse(dataObject.partien[i][type].spieler)}}</span>
                        <span v-if="dataObject.partien[i][type].oeR && !dataObject.partien[i][type].bR">österr. Rekord</span>
                        <span v-if="dataObject.partien[i][type].oeR && dataObject.partien[i][type].bR">österr. Rek., Bahnrek.</span>
                        <span v-if="!dataObject.partien[i][type].oeR && dataObject.partien[i][type].bR">Bahnrekord</span>
                    </div>
                </td>
                <td>
                    <span v-if="!isLeer">{{dataObject.partien[i][type].fehlwuerfe}}</span>
                </td>
                <td v-if="isCup" class="text-center pa-0">
                    <div class="borderBottom paddingTwoLine px-1">Volle</div>
                    <div class="paddingTwoLine">Abr.</div>
                </td>
                <td v-for="j in 4" :key="j" class="pa-0" style="vertical-align: top">
                    <div class="borderBottom paddingTwoLine" style="height: 21px">
                        <span v-if="!isLeer">{{dataObject.partien[i][type].input['d'+j]}}</span>
                    </div>
                    <div class="paddingTwoLine">
                        <span v-if="!isLeer && !isCup">{{dataObject.partien[i][type]['sp'+j]}}</span>
                        <span v-else-if="!isLeer && isCup">{{dataObject.partien[i][type].inputAr['ar'+j]}}</span>
                    </div>
                </td>
                <td v-if="!isCup"  class="pa-0 font-weight-bold" style="vertical-align: top">
                    <div class="borderBottom paddingTwoLine" style="height: 21px">
                        <span v-if="!isLeer">{{dataObject.partien[i][type].kegel}}</span>
                    </div>
                    <div class="paddingTwoLine">
                        <span v-if="!isLeer">{{dataObject.partien[i][type].sp}}</span>
                    </div>
                <td class="font-weight-bold borderRight">
                    <span v-if="!isLeer && !isCup">{{dataObject.partien[i][type].mp}}</span>
                    <span v-else-if="!isLeer">{{dataObject.partien[i][type].kegel}}</span>
                </td>
            </tr>
        </table>
        <table class="smallText text-center borderBottom">
            <tr class="grey lighten-3">
                <td class="text-left pl-2 font-weight-bold py-1 borderRight" colspan="2">
                    Ersatzspieler/innen (max. {{ dataObject.getMaxNrOfErlaubteWechsel() }} Wechsel erlaubt)
                </td>
            </tr>
            <tr v-for="i in dataObject.getNrOfErsatzspielerDefined(type)" :key="i"
                class="text-left">
                <td :class="[{'ersatz': numberOfErsatzSpieler>2}, 'pl-2']" style="max-width: 100px">
                    <span class="caption grey--text text--darken-1">
                        {{dataObject[type].ersatzSpieler[i].name.substr(0,6)}}
                    </span>
                        {{dataObject[type].ersatzSpieler[i].name.substr(8)}}
                    <!--<div class="caption grey--text text--darken-1 d-inline-block mr-2"
                         style="float: right">
                        <span>{{dataObject.getAltersklasse(dataObject[type].ersatzSpieler[i])}}</span>
                    </div>-->
                </td>
                <td v-if="!isLeer" :class="[{'ersatz': numberOfErsatzSpieler>2}, 'borderRight']"
                     style="max-width: 180px">
                    <span v-if="dataObject.getEintauschText(dataObject[type].ersatzSpieler[i])">
                        <span v-for="(txtPart, j) in dataObject.getEintauschText(dataObject[type].ersatzSpieler[i])"
                              :key="j" :class="[{'font-weight-bold': j%2 === 1}]">
                                {{txtPart}}
                        </span>
                    </span>
                    <span v-else>
                        kein Einsatz
                    </span>
                </td>
                <td v-else :class="[{'ersatz': numberOfErsatzSpieler>2}, 'borderRight']"
                    style="width: 280px">
                </td>
            </tr>
            <tr v-if="dataObject.getNrOfErsatzspielerDefined(type)===0">
                <td class="borderRight py-3 text-left">
                    Keine Ersatzspieler/innen aufgestellt!
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "spiel-bericht-print-team",
        props: ['dataObject', 'type', 'isLeer'],
        computed: {
            isCup(){ return this.dataObject.saison.isCup},
            label(){ return this.type === 'heim' ? 'Heim' : 'Gast'; },
            numberOfSpieler() { return Object.keys(this.dataObject.partien).length; },
            numberOfErsatzSpieler() { return Object.keys(this.dataObject.heim.ersatzSpieler).length; },
        },
    }
</script>

<style scoped>
    table {width: 100%; border-spacing: 0; table-layout: auto;  }
    td {border-top: solid 1px grey; border-left: solid 1px grey; padding: 2px 6px}
    .noBorder {border: none}
    .borderRight { border-right: 1px solid grey}
    .borderBottom { border-bottom: 1px solid grey}
    .paddingTwoLine {padding-top: 2px}
    .paddingTop1 { padding-top: 1px}
    .smallText {font-size: 12px}
    .spieler {
        padding-top: 4px;
        width: 100%; max-width: 0;
    }
    .ersatz {
        white-space: nowrap; text-overflow:ellipsis; overflow: hidden;
    }

</style>